// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3i4jm","rootCenter":"LoadMoreObserver_rootCenter__3jmP1","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__w97vT"};